import React, { useState } from 'react'

import { AiFeature } from '../../../../../../../../models/AiFeature'
import { AiResult } from '../../../../../../../../models/AiResult'
import { Tooltip } from '../../../../../../../../components/Tooltip/Tooltip'
import { Button } from '../../../../../../../../components/Button/Button'
import { AddResultToEmailProviderModal } from '../../../../../../../../views/MeetingSummary/EmailProvider/AddResultToEmailProviderModal'
import { selectCurrentUser } from '../../../../../../../../store/meetingSummary/user'
import { useAppSelector } from '../../../../../../../../store/hooks'

import './HeaderResultEmailButton.scss'
import { getMailIntegrationServiceLabel, IntegrationServiceId } from '../../../../../../../../common/integrations'
import { IntegrationIcon } from '../../../../../../../../components/IntegrationIcon'

export interface HeaderResultEmailButtonProps {
  aiFeature: AiFeature
  aiResult: AiResult
  serviceId: string
}

export const HeaderResultEmailButton: React.FC<HeaderResultEmailButtonProps> = ({ aiFeature, aiResult, serviceId }) => {
  const currentUser = useAppSelector(selectCurrentUser)

  const { integrations: currentUserIntegrations } = currentUser ?? {}

  const [show, setShow] = useState(false)

  const userHasIntegration = currentUserIntegrations?.some((e) => e.serviceId === serviceId)

  if (!userHasIntegration) {
    return null
  }

  return (
    <div className='d-none d-md-flex'>
      {show && <AddResultToEmailProviderModal aiFeature={aiFeature} aiResult={aiResult} show={show} onHide={() => setShow(false)} serviceId={serviceId} />}
      <Tooltip className='paragraph-small' title={`Save to ${getMailIntegrationServiceLabel(serviceId)}`} placement='top' offset={[0, 10]}>
        <Button className='px-2' variant='header' onClick={() => setShow((show) => !show)}>
          <IntegrationIcon serviceId={serviceId as IntegrationServiceId} className='email-icon' fill='var(--zocks-gray-900)' />
        </Button>
      </Tooltip>
    </div>
  )
}
